import { render, staticRenderFns } from "./colContent.vue?vue&type=template&id=366adfe4"
import script from "./colContent.vue?vue&type=script&lang=js"
export * from "./colContent.vue?vue&type=script&lang=js"
import style0 from "./colContent.vue?vue&type=style&index=0&id=366adfe4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports